import { action, makeObservable, observable } from 'mobx';

export class MessageManager {
  @observable messageMap = new Map();

  @action
  updateMessage = (lessonElementId, message) => {
    this.messageMap.set(lessonElementId, message);
  }

  getMessage = (lessonItemId) => {
    const message = this.messageMap.get(lessonItemId);
    if (!message) {
      return {};
    }
    return message;
  }

  constructor() {
    makeObservable(this);
  }
}

export default new MessageManager();
